import { render, staticRenderFns } from "./StudyPlanView.vue?vue&type=template&id=e56e5df0"
import script from "./StudyPlanView.vue?vue&type=script&lang=js"
export * from "./StudyPlanView.vue?vue&type=script&lang=js"
import style0 from "./StudyPlanView.vue?vue&type=style&index=0&id=e56e5df0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports